module.exports = __webpack_public_path__ + "static/img/GB.8e6ee4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certified_shipping/GB.png
// module id = bBlr
// module chunks = 2